/* eslint-disable */

<template>
  <div>
    <vue-sortable :options="options" @drag:start="startedDrag" @drag:stop="stoppedDrag" @sortable:sort="sort">
      <div :class="{ 'cursor-drag': draggingCard === true }" class="vx-row">
        <div class="vx-col lg:w-3/12 md:w-3/12 sm:w-5/5">
          <vx-card class="mb-4">
            <h3 class="font-bold mb-4">Controls</h3>
            <vue-draggable-container id="wordBank" class="inline-block wordBank">
              <h5 class="dragBlock my-1 font-semibold cursor-pointer">
                <img src="https://rapidsimulations.com/simulations/2/images/tower-pc.png" width="20" />
                <span class="ml-2">Sales PC</span>
              </h5>
              <h5 class="dragBlock my-1 font-semibold cursor-pointer">
                <img src="https://rapidsimulations.com/simulations/2/images/tower-pc.png" width="20" />
                <span class="ml-2">Sales PC</span>
              </h5>
              <h5 class="dragBlock my-1 font-semibold cursor-pointer">
                <img src="https://rapidsimulations.com/simulations/2/images/server-5.png" width="20" />
                <span class="ml-2">Sales Server</span>
              </h5>
              <h5 class="dragBlock my-1 font-semibold cursor-pointer">
                <img src="https://rapidsimulations.com/simulations/2/images/tower-pc.png" width="20" />
                <span class="ml-2">Layer 3 Switch</span>
              </h5>
              <h5 class="dragBlock my-1 font-semibold cursor-pointer">
                <img src="https://rapidsimulations.com/simulations/2/images/tower-pc.png" width="20" />
                <span class="ml-2">Layer 2 Switch</span>
              </h5>
              <h5 class="dragBlock my-1 font-semibold cursor-pointer">
                <img src="https://rapidsimulations.com/simulations/2/images/tower-pc.png" width="20" />
                <span class="ml-2">Router</span>
              </h5>
              <h5 class="dragBlock my-1 font-semibold cursor-pointer">
                <img src="https://rapidsimulations.com/simulations/2/images/network1.png" width="20" />
                <span class="ml-2">HR VLAN 22</span>
              </h5>
              <h5 class="dragBlock my-1 font-semibold cursor-pointer">
                <img src="https://rapidsimulations.com/simulations/2/images/network1.png" width="20" />
                <span class="ml-2">HR VLAN 22</span>
              </h5>
              <h5 class="dragBlock my-1 font-semibold cursor-pointer">
                <img src="https://rapidsimulations.com/simulations/2/images/network1.png" width="20" />
                <span class="ml-2">Finance VLAN 22</span>
              </h5>
              <h5 class="dragBlock my-1 font-semibold cursor-pointer">
                <img src="https://rapidsimulations.com/simulations/2/images/tower-pc.png" width="20" />
                <span class="ml-2">HR PC</span>
              </h5>
              <h5 class="dragBlock my-1 font-semibold cursor-pointer">
                <img src="https://rapidsimulations.com/simulations/2/images/tower-pc.png" width="20" />
                <span class="ml-2">HR PC</span>
              </h5>
              <h5 class="dragBlock my-1 font-semibold cursor-pointer">
                <img src="https://rapidsimulations.com/simulations/2/images/tower-pc.png" width="20" />
                <span class="ml-2">Finance PC</span>
              </h5>
              <h5 class="dragBlock my-1 font-semibold cursor-pointer">
                <img src="https://rapidsimulations.com/simulations/2/images/tower-pc.png" width="20" />
                <span class="ml-2">Finance PC</span>
              </h5>
            </vue-draggable-container>
          </vx-card>
        </div>
        <div class="vx-col lg:w-9/12 md:w-9/12 sm:w-5/5">
          <vx-card class="mb-base">
            <div class="p-4">
              <div class="vx-row mb-16 mt-16">
                <div class="vx-col w-1/4 block-center">
                  <div class="sim-block-card" style="min-width: 10vw; padding-top: 5px">
                    <div class="flex justify-between align-middle items-center">
                      <h1 class="sim-block-text mb-1 text-left">VLAN</h1>
                      <img draggable="false" alt="" src="https://rapidsimulations.com/simulations/2/images/network1.png" width="30" />
                    </div>
                    <vue-draggable-container id="input0" class="answerStandard dropzone dropzoneStandard answer-bg my-2" />
                  </div>
                  <div class="line-row-1-h"></div>
                </div>
                <div class="vx-col w-1/4 block-center">
                  <div class="sim-block-card bg-danger">
                    <div class="sim-block-image">
                      <img
                        draggable="false"
                        alt=""
                        src="https://cdn.discordapp.com/attachments/746242308084858900/811013895367426058/server_1.png"
                        width="60"
                      />
                    </div>
                    <h2 class="font-bold">HR Server</h2>
                  </div>
                </div>
                <div class="vx-col w-1/4 block-center"></div>
                <div class="vx-col w-1/4 block-center"></div>
              </div>

              <div class="vx-row mb-16 mt-16">
                <div class="vx-col w-1/4 block-center">
                  <div class="sim-block-card" style="min-width: 10vw">
                    <vue-draggable-container id="input1" class="answerStandard dropzone dropzoneStandard answer-bg my-1" />
                  </div>
                  <div class="line-col-1-d"></div>
                  <div class="line-row-2-h"></div>
                </div>
                <div class="vx-col w-1/4 block-center">
                  <div class="sim-block-card" style="min-width: 10vw; padding-top: 5px">
                    <div class="flex justify-between align-middle items-center">
                      <h1 class="sim-block-text mb-1 text-left">VLAN</h1>
                      <img draggable="false" alt="" src="https://rapidsimulations.com/simulations/2/images/network1.png" width="30" />
                    </div>
                    <vue-draggable-container id="input2" class="answerStandard dropzone dropzoneStandard answer-bg my-2" />
                  </div>
                </div>
                <div class="vx-col w-1/4 block-center">
                  <div class="sim-block-card" style="min-width: 10vw">
                    <vue-draggable-container id="input3" class="answerStandard dropzone dropzoneStandard answer-bg my-1" />
                    <vue-draggable-container id="input4" class="answerStandard dropzone dropzoneStandard answer-bg my-1" />
                  </div>
                </div>
                <div class="vx-col w-1/4 block-center"></div>
              </div>

              <div class="vx-row mb-16 mt-16">
                <div class="vx-col w-1/4 block-center">
                  <div class="sim-block-card" style="min-width: 10vw; padding-top: 5px">
                    <div class="flex justify-between align-middle items-center">
                      <h1 class="sim-block-text mb-1 text-left">VLAN</h1>
                      <img draggable="false" alt="" src="https://rapidsimulations.com/simulations/2/images/network1.png" width="30" />
                    </div>
                    <vue-draggable-container id="input5" class="answerStandard dropzone dropzoneStandard answer-bg my-2" />
                  </div>
                  <div class="line-row-2-h"></div>
                </div>
                <div class="vx-col w-1/4 block-center">
                  <div class="sim-block-card bg-danger">
                    <div class="sim-block-image">
                      <img
                        draggable="false"
                        alt=""
                        src="https://cdn.discordapp.com/attachments/746242308084858900/811013895367426058/server_1.png"
                        width="60"
                      />
                    </div>
                    <h2 class="font-bold">Finance Server</h2>
                  </div>
                </div>
                <div class="vx-col w-1/4 block-center">
                  <div class="sim-block-card" style="min-width: 10vw">
                    <vue-draggable-container id="input6" class="answerStandard dropzone dropzoneStandard answer-bg my-1" />
                    <vue-draggable-container id="input7" class="answerStandard dropzone dropzoneStandard answer-bg my-1" />
                  </div>
                </div>
                <div class="vx-col w-1/4 block-center"></div>
              </div>

              <div class="vx-row mb-16 mt-16">
                <div class="vx-col w-1/4 block-center">
                  <div class="sim-block-card" style="min-width: 10vw; padding-top: 5px">
                    <div class="flex justify-between align-middle items-center">
                      <h1 class="sim-block-text mb-1 text-left">T1</h1>
                      <img
                        draggable="false"
                        alt=""
                        src="https://rapidsimulations.com/simulations/2/images/cloud-computing-p-500.png"
                        width="30"
                      />
                    </div>
                    <vue-draggable-container id="input8" class="answerStandard dropzone dropzoneStandard answer-bg my-2" />
                  </div>
                  <div class="line-row-3-h"></div>
                </div>
                <div class="vx-col w-1/4 block-center">
                  <div class="sim-block-card" style="min-width: 10vw">
                    <vue-draggable-container id="input9" class="answerStandard dropzone dropzoneStandard answer-bg my-1" />
                  </div>
                </div>
                <div class="vx-col w-1/4 block-center">
                  <div class="sim-block-card bg-danger">
                    <div class="sim-block-image">
                      <img draggable="false" alt="" src="https://rapidsimulations.com/simulations/2/images/network1.png" width="60" />
                    </div>
                    <h2 class="font-bold">Sales VLAN 12</h2>
                  </div>
                </div>
                <div class="vx-col w-1/4 block-center">
                  <div class="sim-block-card" style="min-width: 10vw">
                    <vue-draggable-container id="input10" class="answerStandard dropzone dropzoneStandard answer-bg my-1" />
                  </div>
                  <div class="line-col-4-d"></div>
                </div>
              </div>

              <div class="vx-row mb-16 mt-16">
                <div class="vx-col w-1/4 block-center"></div>
                <div class="vx-col w-1/4 block-center"></div>
                <div class="vx-col w-1/4 block-center"></div>
                <div class="vx-col w-1/4 block-center">
                  <div class="sim-block-card" style="min-width: 10vw">
                    <vue-draggable-container id="input11" class="answerStandard dropzone dropzoneStandard answer-bg my-1" />
                    <vue-draggable-container id="input12" class="answerStandard dropzone dropzoneStandard answer-bg my-1" />
                  </div>
                </div>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </vue-sortable>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import Prism from 'vue-prism-component';
import vSelect from 'vue-select';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      draggingCard: false,

      options: {
        draggable: '.dragBlock',
        dropzone: '.dropzoneStandard',
      },
    };
  },
  methods: {
    startedDrag(x) {
      x.data.source.className += ' currently-dragging-standard';
      this.draggingCard = true;
    },
    stoppedDrag() {
      this.draggingCard = false;
    },
    sort(x) {
      const overContainer = x.data.dragEvent.data.overContainer;
      const sourceContainer = x.data.dragEvent.data.sourceContainer;
      if (overContainer && overContainer.id !== 'wordBank' && overContainer.children) {
        if (overContainer.children.length > 0 && overContainer.id !== sourceContainer.id) {
          //this.drag_error()
          x.cancel();
        }
      }
    },
    markSimulation() {
      let totalScore = 0;

      if (document.getElementById('input0').textContent === 'HR VLAN 22') {
        document.getElementById('input0').style.borderColor = '#28C76F';
        document.getElementById('input0').style.backgroundColor = '#28C76F';
        totalScore++;
      } else {
        document.getElementById('input0').style.borderColor = '#fd4445';
        document.getElementById('input0').style.backgroundColor = '#fd4445';
      }

      if (document.getElementById('input1').textContent === 'Layer 2 Switch') {
        document.getElementById('input1').style.borderColor = '#28C76F';
        document.getElementById('input1').style.backgroundColor = '#28C76F';
        totalScore++;
      } else {
        document.getElementById('input1').style.borderColor = '#fd4445';
        document.getElementById('input1').style.backgroundColor = '#fd4445';
      }

      if (document.getElementById('input2').textContent === 'HR VLAN 22') {
        document.getElementById('input2').style.borderColor = '#28C76F';
        document.getElementById('input2').style.backgroundColor = '#28C76F';
        totalScore++;
      } else {
        document.getElementById('input2').style.borderColor = '#fd4445';
        document.getElementById('input2').style.backgroundColor = '#fd4445';
      }

      if (document.getElementById('input3').textContent === 'HR PC') {
        document.getElementById('input3').style.borderColor = '#28C76F';
        document.getElementById('input3').style.backgroundColor = '#28C76F';
        totalScore++;
      } else {
        document.getElementById('input3').style.borderColor = '#fd4445';
        document.getElementById('input3').style.backgroundColor = '#fd4445';
      }

      if (document.getElementById('input4').textContent === 'HR PC') {
        document.getElementById('input4').style.borderColor = '#28C76F';
        document.getElementById('input4').style.backgroundColor = '#28C76F';
        totalScore++;
      } else {
        document.getElementById('input4').style.borderColor = '#fd4445';
        document.getElementById('input4').style.backgroundColor = '#fd4445';
      }

      if (document.getElementById('input5').textContent === 'Finance VLAN 22') {
        document.getElementById('input5').style.borderColor = '#28C76F';
        document.getElementById('input5').style.backgroundColor = '#28C76F';
        totalScore++;
      } else {
        document.getElementById('input5').style.borderColor = '#fd4445';
        document.getElementById('input5').style.backgroundColor = '#fd4445';
      }

      if (document.getElementById('input6').textContent === 'Finance PC') {
        document.getElementById('input6').style.borderColor = '#28C76F';
        document.getElementById('input6').style.backgroundColor = '#28C76F';
        totalScore++;
      } else {
        document.getElementById('input6').style.borderColor = '#fd4445';
        document.getElementById('input6').style.backgroundColor = '#fd4445';
      }

      if (document.getElementById('input7').textContent === 'Finance PC') {
        document.getElementById('input7').style.borderColor = '#28C76F';
        document.getElementById('input7').style.backgroundColor = '#28C76F';
        totalScore++;
      } else {
        document.getElementById('input7').style.borderColor = '#fd4445';
        document.getElementById('input7').style.backgroundColor = '#fd4445';
      }

      if (document.getElementById('input8').textContent === 'Router') {
        document.getElementById('input8').style.borderColor = '#28C76F';
        document.getElementById('input8').style.backgroundColor = '#28C76F';
        totalScore++;
      } else {
        document.getElementById('input8').style.borderColor = '#fd4445';
        document.getElementById('input8').style.backgroundColor = '#fd4445';
      }

      if (document.getElementById('input9').textContent === 'Layer 3 Switch') {
        document.getElementById('input9').style.borderColor = '#28C76F';
        document.getElementById('input9').style.backgroundColor = '#28C76F';
        totalScore++;
      } else {
        document.getElementById('input9').style.borderColor = '#fd4445';
        document.getElementById('input9').style.backgroundColor = '#fd4445';
      }

      if (document.getElementById('input10').textContent === 'Sales Server') {
        document.getElementById('input10').style.borderColor = '#28C76F';
        document.getElementById('input10').style.backgroundColor = '#28C76F';
        totalScore++;
      } else {
        document.getElementById('input10').style.borderColor = '#fd4445';
        document.getElementById('input10').style.backgroundColor = '#fd4445';
      }

      if (document.getElementById('input11').textContent === 'Sales PC') {
        document.getElementById('input11').style.borderColor = '#28C76F';
        document.getElementById('input11').style.backgroundColor = '#28C76F';
        totalScore++;
      } else {
        document.getElementById('input11').style.borderColor = '#fd4445';
        document.getElementById('input11').style.backgroundColor = '#fd4445';
      }

      if (document.getElementById('input12').textContent === 'Sales PC') {
        document.getElementById('input12').style.borderColor = '#28C76F';
        document.getElementById('input12').style.backgroundColor = '#28C76F';
        totalScore++;
      } else {
        document.getElementById('input12').style.borderColor = '#fd4445';
        document.getElementById('input12').style.backgroundColor = '#fd4445';
      }

      if (totalScore === this.dataLocal.simulation.totalScore) {
        return this.$emit('simulation_full_correct', totalScore);
      }
      this.$emit('simulation_getting_there', totalScore);
    },
  },
  components: {
    draggable,
    Prism,
    vSelect,
  },
  created() {},
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/views/platform/modules/simulations/legacy/css/CompTIA/Network+/Lgx279928282164494336.scss';
</style>
